module.exports = __webpack_public_path__ + "ptc_nakagawa_H1_2.c0c0cb97.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_H1_2.jpg
// module id = TqSR
// module chunks = 0